<template>
  <div>
    <div class="main-title">学员登记</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add()">添加登记</el-button>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.company_id"
              filterable
              style="width:194px;"
              @change="search()"
              placeholder="搜索考场">
              <el-option label="全部考场" :value="null"></el-option>
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索驾校名称"
              v-model="searchForm.school_name"
              prefix-icon="el-icon-search"
              clearable
              style="width:160px;"
              @input="inputSearch()">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索教练姓名"
              v-model="searchForm.coach_name"
              prefix-icon="el-icon-search"
              clearable
              style="width:140px;"
              @input="inputSearch()">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索姓名或身份证号"
              v-model="searchForm.keyword"
              prefix-icon="el-icon-search"
              clearable
              style="width:220px;"
              @input="inputSearch()">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.date_range"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width:240px;"
              @change="search()">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.car_status"
              placeholder="分车状态"
              clearable
              style="width:120px;"
              @change="search()">
              <el-option label="未分车" value="未分车"></el-option>
              <el-option label="已分车" value="已分车"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-picture-outline" size="small" @click="showQrcode()">扫码登记</el-button>
          <el-button icon="el-icon-download" size="small" @click="excel()" :loading="exporting"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="load()" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%"
        v-loading="loading"
        show-summary
        :summary-method="getSummaries"
        @sort-change="sortChange">
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column prop="school_name" label="驾校名称" width="150" sortable="custom"></el-table-column>
        <el-table-column prop="coach_name" label="教练姓名" width="100" sortable="custom"></el-table-column>
        <el-table-column prop="student_name" label="学员姓名" width="100"></el-table-column>
        <el-table-column prop="idcard" label="身份证号" width="180"></el-table-column>
        <el-table-column prop="car_type" label="培训车型" width="90" sortable="custom"></el-table-column>
        <el-table-column label="分车状态" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.car_status === '已分车' ? 'success' : 'info'">
              {{ scope.row.car_status || '未分车' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="来源" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.source === 'h5' ? 'success' : ''">
              {{ scope.row.source === 'h5' ? '手机扫码' : '后台录入' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="登记时间" width="160"></el-table-column>
        <el-table-column prop="price" label="金额" width="100" sortable="custom"></el-table-column>
        <el-table-column label="照片" width="70">
          <template slot-scope="scope">
            <img
              v-if="scope.row.face_photo_url"
              :src="scope.row.face_photo_url"
              style="width:40px;height:40px;object-fit:cover;border-radius:4px;cursor:pointer;"
              @click="openCamera(scope.row)" />
            <span v-else style="color:#ccc;font-size:12px;">未拍</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" @click="openCamera(scope.row)">拍照授权</el-button>
            <el-button type="text" style="color:red;" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 添加/修改登记 -->
    <el-dialog :title="form.id > 0 ? '修改登记信息' : '添加登记'" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="120px">
        <el-form-item label="所属考场">
          <el-select v-model="form.company_id" style="width:250px;" placeholder="请选择所属考场" filterable>
            <el-option label="未指定" :value="0"></el-option>
            <el-option
              v-for="item in companyList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="驾校名称">
          <el-input v-model="form.school_name" style="width:250px;" placeholder="请输入驾校名称"></el-input>
        </el-form-item>
        <el-form-item label="教练姓名">
          <el-input v-model="form.coach_name" style="width:250px;" placeholder="请输入教练姓名"></el-input>
        </el-form-item>
        <el-form-item prop="student_name" label="学员姓名">
          <el-input v-model="form.student_name" style="width:250px;" placeholder="请输入学员姓名"></el-input>
        </el-form-item>
        <el-form-item prop="idcard" label="身份证号">
          <el-input v-model="form.idcard" style="width:250px;" placeholder="请输入身份证号码" maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="培训车型">
          <el-select v-model="form.car_type" style="width:250px;" placeholder="请选择培训车型">
            <el-option label="请选择" value=""></el-option>
            <el-option label="C1" value="C1"></el-option>
            <el-option label="C2" value="C2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额">
          <el-input-number v-model="form.price" :precision="2" :step="1" :min="0" style="width:250px;"></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark" :rows="3" style="width:250px;" placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commit()" :loading="commiting">确 定</el-button>
        <el-button @click="formVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 扫码登记 -->
    <el-dialog title="扫码登记" :visible.sync="qrcodeVisible" width="480px">
      <div style="margin-bottom:12px;">
        <span style="font-size:13px;color:#666;">选择考场：</span>
        <el-select v-model="qrcodeCompanyId" style="width:200px;" placeholder="不限考场" clearable @change="renderQrcode">
          <el-option
            v-for="item in companyList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="text-align:center;padding:20px 0;">
        <canvas ref="qrcodeCanvas"></canvas>
      </div>
      <div style="text-align:center;color:#909399;font-size:12px;margin-bottom:10px;">学员可通过微信或浏览器扫描二维码，自助填写登记信息。</div>
      <div slot="footer" style="text-align:center;">
        <el-button type="primary" icon="el-icon-download" @click="downloadQrcode">下载二维码图片</el-button>
        <el-button @click="qrcodeVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 拍照 -->
    <el-dialog
      title="学员拍照"
      :visible.sync="cameraDialogVisible"
      width="540px"
      :close-on-click-modal="false"
      @close="closeCamera">
      <div style="text-align:center;">
        <p style="margin:0 0 10px;color:#666;">
          学员：<strong>{{ currentStudent ? currentStudent.student_name : '' }}</strong>
          &nbsp;&nbsp;身份证：{{ currentStudent ? currentStudent.idcard : '' }}
        </p>
        <div v-show="!capturedPhoto">
          <video
            ref="video"
            autoplay
            playsinline
            style="width:480px;height:360px;background:#222;border-radius:4px;display:block;margin:0 auto;">
          </video>
        </div>
        <div v-if="capturedPhoto" style="position:relative;display:inline-block;">
          <img
            :src="capturedPhoto"
            style="width:480px;height:360px;object-fit:contain;border-radius:4px;border:1px solid #ddd;display:block;" />
          <div v-if="authorizing" style="position:absolute;inset:0;background:rgba(0,0,0,0.45);border-radius:4px;display:flex;align-items:center;justify-content:center;">
            <span style="color:#fff;font-size:16px;"><i class="el-icon-loading"></i> 正在保存...</span>
          </div>
          <div v-if="authError" style="margin-top:8px;color:#f56c6c;font-size:13px;">{{ authError }}</div>
        </div>
        <canvas ref="canvas" style="display:none;" width="480" height="360"></canvas>
      </div>
      <div slot="footer" style="text-align:center;">
        <template v-if="!capturedPhoto">
          <el-button type="primary" icon="el-icon-camera" @click="capturePhoto" :disabled="!cameraReady">拍 照</el-button>
        </template>
        <template v-else-if="authError">
          <el-button icon="el-icon-refresh" @click="retakePhoto">重 拍</el-button>
        </template>
        <el-button @click="closeCamera" :disabled="authorizing" style="margin-left:10px;">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  props: {
    user: Object,
    tableHeight: Number
  },
  data () {
    return {
      list: [],
      total: 0,
      loading: false,
      currentPage: 1,
      pageSize: 200,
      companyList: [],
      searchForm: {
        company_id: null,
        school_name: '',
        coach_name: '',
        keyword: '',
        car_status: null,
        date_range: [new Date().toISOString().split('T')[0], new Date().toISOString().split('T')[0]]
      },
      searchTimer: null,
      sortField: '',
      sortOrder: '',
      formVisible: false,
      commiting: false,
      exporting: false,
      form: this.emptyForm(),
      formRules: {
        student_name: [{ required: true, message: '请填写学员姓名', trigger: 'blur' }],
        idcard: [{ required: true, message: '请填写身份证号', trigger: 'blur' }]
      },
      qrcodeVisible: false,
      qrcodeCompanyId: null,
      cameraDialogVisible: false,
      currentStudent: null,
      capturedPhoto: null,
      cameraReady: false,
      authorizing: false,
      authError: '',
      videoStream: null
    }
  },
  computed: {
    h5Url () {
      const base = window.location.protocol + '//' + (process.env.NODE_ENV === 'production' ? 'kcapi.codetrust.cn' : 'localhost:20184')
      const gid = this.user.group_id
      const cid = this.qrcodeCompanyId || 0
      return `${base}/h5/student-register?gid=${gid}&cid=${cid}`
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    emptyForm () {
      return { id: 0, school_name: '', coach_name: '', student_name: '', idcard: '', car_type: '', company_id: 0, remark: '', price: 0 }
    },
    fetchCompanyList () {
      this.$http.get('/dbapi/company_combo').then(res => {
        if (res.data.success) {
          this.companyList = res.data.list
          if (this.companyList.length > 0 && !this.searchForm.company_id) {
            this.searchForm.company_id = this.companyList[0].value
            this.load()
          }
        }
      })
    },
    load () {
      this.loading = true
      const params = {
        page: this.currentPage,
        page_size: this.pageSize,
        sort_field: this.sortField,
        sort_order: this.sortOrder,
        ...this.searchForm,
        date_range: JSON.stringify(this.searchForm.date_range)
      }
      this.$http.get('/gate/student-register', { params }).then(res => {
        this.loading = false
        if (res.data.success) {
          this.list = res.data.list
          this.total = res.data.total
        }
      }).catch(() => { this.loading = false })
    },
    search () {
      this.currentPage = 1
      this.load()
    },
    inputSearch () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => { this.search() }, 400)
    },
    sortChange ({ prop, order }) {
      this.sortField = order ? prop : ''
      this.sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : ''
      this.currentPage = 1
      this.load()
    },
    pageSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.load()
    },
    pageChange (val) {
      this.currentPage = val
      this.load()
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.property === 'price') {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0).toFixed(2)
          } else {
            sums[index] = '0.00'
          }
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    excel () {
      this.exporting = true
      const params = {
        ...this.searchForm,
        date_range: JSON.stringify(this.searchForm.date_range)
      }
      this.$http.get('/gate/student-register/excel', { params }).then(res => {
        this.exporting = false
        if (res.data.success) {
          this.$alert('导出成功,点击下载文件', '导出成功', {
            confirmButtonText: '下载文件',
            callback: action => {
              if (action === 'confirm') {
                window.open(res.data.url)
              }
            }
          })
        } else {
          this.$message({ type: 'error', message: '导出失败,' + res.data.message })
        }
      }).catch(() => { this.exporting = false })
    },
    add () {
      this.form = this.emptyForm()
      this.form.company_id = this.searchForm.company_id || 0
      this.formVisible = true
    },
    edit (row) {
      this.form = {
        id: row.id,
        school_name: row.school_name,
        coach_name: row.coach_name,
        student_name: row.student_name,
        idcard: row.idcard,
        car_type: row.car_type,
        company_id: row.company_id,
        remark: row.remark,
        price: row.price || 0
      }
      this.formVisible = true
    },
    commit () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.commiting = true
        this.$http.post('/gate/student-register/save', this.form).then(res => {
          this.commiting = false
          if (res.data.success) {
            this.formVisible = false
            this.$message({ type: 'success', message: res.data.message })
            this.load()
          } else {
            this.$message({ type: 'error', message: res.data.message })
          }
        }).catch(() => { this.commiting = false })
      })
    },
    del (row) {
      this.$confirm('确定要删除这条登记记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/gate/student-register/delete', { id: row.id }).then(res => {
          if (res.data.success) {
            this.$message({ type: 'success', message: '已删除' })
            this.load()
          } else {
            this.$message({ type: 'error', message: res.data.message })
          }
        })
      })
    },
    showQrcode () {
      this.qrcodeCompanyId = this.searchForm.company_id || null
      this.qrcodeVisible = true
      this.$nextTick(() => { this.renderQrcode() })
    },
    renderQrcode () {
      const canvas = this.$refs.qrcodeCanvas
      if (!canvas) return
      QRCode.toCanvas(canvas, this.h5Url, { width: 280, margin: 2 }, () => {})
    },
    downloadQrcode () {
      const canvas = this.$refs.qrcodeCanvas
      if (!canvas) return
      const link = document.createElement('a')
      link.download = '扫码登记二维码.png'
      link.href = canvas.toDataURL('image/png')
      link.click()
    },
    openCamera (row) {
      if (!row.idcard) {
        return this.$message.error('该学员未录入身份证号，无法授权')
      }
      this.currentStudent = row
      this.capturedPhoto = null
      this.cameraReady = false
      this.cameraDialogVisible = true
      this.$nextTick(() => { this.startCamera() })
    },
    startCamera () {
      navigator.mediaDevices.getUserMedia({ video: { width: 480, height: 360, facingMode: 'user' } })
        .then(stream => {
          this.videoStream = stream
          this.$refs.video.srcObject = stream
          this.cameraReady = true
        })
        .catch(err => {
          this.$message.error('无法访问摄像头：' + err.message)
          this.cameraDialogVisible = false
        })
    },
    capturePhoto () {
      const canvas = this.$refs.canvas
      canvas.getContext('2d').drawImage(this.$refs.video, 0, 0, 480, 360)
      this.capturedPhoto = canvas.toDataURL('image/jpeg', 0.9)
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(t => t.stop())
        this.videoStream = null
      }
      this.submitAuth()
    },
    retakePhoto () {
      this.capturedPhoto = null
      this.authError = ''
      this.cameraReady = false
      this.$nextTick(() => { this.startCamera() })
    },
    closeCamera () {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(t => t.stop())
        this.videoStream = null
      }
      this.cameraDialogVisible = false
      this.capturedPhoto = null
      this.currentStudent = null
      this.cameraReady = false
      this.authError = ''
    },
    dataUrlToBlob (dataUrl) {
      const arr = dataUrl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      const u8arr = new Uint8Array(bstr.length)
      for (let i = 0; i < bstr.length; i++) {
        u8arr[i] = bstr.charCodeAt(i)
      }
      return new Blob([u8arr], { type: mime })
    },
    submitAuth () {
      if (!this.capturedPhoto || !this.currentStudent) return
      this.authorizing = true
      this.authError = ''
      const blob = this.dataUrlToBlob(this.capturedPhoto)
      const formData = new FormData()
      formData.append('file', blob, `register_${this.currentStudent.id}_${Date.now()}.jpg`)
      this.$http.post('/api/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(uploadRes => {
          if (!uploadRes.data.success) {
            throw new Error('照片上传失败：' + uploadRes.data.message)
          }
          return this.$http.post('/gate/student-register/auth', {
            register_id: this.currentStudent.id,
            photo_url: uploadRes.data.url
          })
        })
        .then(() => {
          this.$message.success('拍照成功')
          this.closeCamera()
          this.load()
        })
        .catch(err => {
          this.authError = err.message || '操作失败，请重拍'
        })
        .finally(() => {
          this.authorizing = false
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/access/StudentRegister.vue